import { parse as urlParse } from 'url';

import { api, getAllSettings, postAndPageFetchOptions } from '../ghost';
import { createNextFeatureImages } from '../ghost-images';
import { GhostPostsOrPages } from '../ghost-interfaces';
import { normalizePost } from '../ghost-normalize';

/**
 * Returns pages by tag
 *
 * @param tagSlugs string[]
 * @param limit number|string|null
 * @param excludeId string|null
 * @param orderBy string
 */
const getPagesByTag = async (
    tagSlugs: string[],
    limit?: number | string,
    excludeId?: string,
    orderBy?: string
): Promise<GhostPostsOrPages> => {
    const exclude = (excludeId && `+id:-${excludeId}`) || ``;
    const filter = `tags.slug:[${tagSlugs.join(',')}]${exclude}`;
    const order = orderBy ? [orderBy, 'published_at DESC'] : postAndPageFetchOptions.order;

    try {
        const pages = await api.pages.browse({
            ...postAndPageFetchOptions,
            ...(limit && { limit: `${limit}` }),
            order,
            filter,
        });

        if (!pages || pages.length === 0) return pages;

        const { url } = await getAllSettings();
        const normalizedPages = await Promise.all(
            pages.map(page => normalizePost(page, (url && urlParse(url)) || undefined, '/'))
        );
        const images = await createNextFeatureImages(Object.assign(normalizedPages, { meta: pages.meta }));
        return images;
    } catch (e) {
        if (process.env.NODE_ENV === 'development') {
            const error = e as { response?: { status: number } };
            if (error.response?.status === 404) {
                // eslint-disable-next-line no-console
                console.error(`Page with filter ${filter} not found.`);
            }
        }
        throw e;
    }
};

export default getPagesByTag;
